import { api } from '../../../lib/api';

export const extCompanyService = {

  async getAllExtCompanies(active_only = true, page = 1, pageSize = 10) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('active_only', active_only);
      queryParams.append('page', page);
      queryParams.append('page_size', pageSize);

      const url = `/api/maintenance/external-companies?${queryParams.toString()}`;
      const data = await api.get(url);
      return data || { data: [], total: 0 };
    } catch (error) {
      console.error('Error fetching external companies:', error);
      throw error;
    }
  },

  async getExtCompanyById(companyId) {
    try {
      const data = await api.get(`/api/maintenance/external-companies/${companyId}`);
      return data || null;
    } catch (error) {
      console.error(`Error fetching external company ${companyId}:`, error);
      throw error;
    }
  },


  async createExtCompany(extCompanyData) {
    try {
      const data = await api.post('/api/maintenance/external-companies', extCompanyData);
      return data;
    } catch (error) {
      console.error('Error creating external company:', error);
      throw error;
    }
  },

  async updateExtCompany(id, updateData) {
    try {
      const data = await api.put(`/api/maintenance/external-companies/${id}`, updateData);
      return data;
    } catch (error) {
      console.error(`Error updating external company ${id}:`, error);
      throw error;
    }
  },


  async deleteExtCompany(id) {
    try {
      await api.delete(`/api/maintenance/external-companies/${id}`);
    } catch (error) {
      console.error(`Error deleting external company ${id}:`, error);
      throw error;
    }
  },

  async getExtEmployeeByExtCompany(extCompanyId, page = 1, pageSize = 10, active_only = true) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('active_only', active_only);
      queryParams.append('page', page);
      queryParams.append('page_size', pageSize);

      const url = `/api/maintenance/external-companies/employees/${extCompanyId}?${queryParams.toString()}`;
      const data = await api.get(url);
      return data || { data: [], total: 0 };
    } catch (error) {
      console.error('Error fetching external employees:', error);
      throw error;
    }
  },

  async createExtEmployee(extCompanyId, extEmployeeData) {
    try {
      const data = await api.post(`/api/maintenance/external-companies/employees/${extCompanyId}`, extEmployeeData);
      return data;
    } catch (error) {
      console.error('Error creating external employee:', error);
      throw error;
    }
  },

  async updateExtEmployee(extEmployeeId, extEmployeeData) {
    try {
      const data = await api.put(`/api/maintenance/external-companies/employees/${extEmployeeId}`, extEmployeeData);
      return data;
    } catch (error) {
      console.error('Error updating external employee:', error);
      throw error;
    }
  },

  async deleteExtEmployee(extEmployeeId) {
    try {
      await api.delete(`/api/maintenance/external-companies/employees/${extEmployeeId}`);
    } catch (error) {
      console.error('Error deleting external employee:', error);
      throw error;
    }
  },

  // Maintenance Contracts
  async getMaintenanceContracts(filters = {}, page = 1, pageSize = 10) {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page);
      queryParams.append('page_size', pageSize);

      if (filters && typeof filters === 'object') {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, value);
          }
        });
      }

      const url = `/api/maintenance/external-companies/contracts?${queryParams.toString()}`;
      const data = await api.get(url);
      return data || { data: [], total: 0 };
    } catch (error) {
      console.error('Error fetching maintenance contracts:', error);
      throw error;
    }
  },

  async getMaintenanceContractById(contractId) {
    try {
      const data = await api.get(`/api/maintenance/external-companies/contracts/${contractId}`);
      return data || null;
    } catch (error) {
      console.error(`Error fetching maintenance contract ${contractId}:`, error);
      throw error;
    }
  },

  async createMaintenanceContract(contractData) {
    try {
      const data = await api.post('/api/maintenance/external-companies/contracts', contractData);
      return data;
    } catch (error) {
      console.error('Error creating maintenance contract:', error);
      throw error;
    }
  },

  async updateMaintenanceContract(contractId, contractData) {
    try {
      const data = await api.put(`/api/maintenance/external-companies/contracts/${contractId}`, contractData);
      return data;
    } catch (error) {
      console.error(`Error updating maintenance contract ${contractId}:`, error);
      throw error;
    }
  },

  async deleteMaintenanceContract(contractId) {
    try {
      await api.delete(`/api/maintenance/external-companies/contracts/${contractId}`);
    } catch (error) {
      console.error(`Error deleting maintenance contract ${contractId}:`, error);
      throw error;
    }
  },

  async getExpiringMaintenanceContracts(days = 30, page = 1, pageSize = 10) {
    try {
      const queryParams = new URLSearchParams();
      if (days !== undefined && days !== null) {
        queryParams.append('days', days);
      }
      queryParams.append('page', page);
      queryParams.append('page_size', pageSize);

      const url = `/api/maintenance/external-companies/contracts/expiring?${queryParams.toString()}`;
      const data = await api.get(url);
      return data || { data: [], total: 0 };
    } catch (error) {
      console.error('Error fetching expiring maintenance contracts:', error);
      throw error;
    }
  }
};
